/**
 * Country list with default fiat currency mapping
 * Used for geo-based fiat auto-selection
 */

export interface Country {
  /** ISO 3166-1 alpha-2 country code (lowercase) */
  code: string;
  /** Display name */
  name: string;
  /** Default fiat currency code for this country */
  defaultFiat: string;
}

export const COUNTRIES: Country[] = [
  { code: 'ad', name: 'Andorra', defaultFiat: 'EUR' },
  { code: 'ae', name: 'United Arab Emirates', defaultFiat: 'AED' },
  { code: 'af', name: 'Afghanistan', defaultFiat: 'USD' },
  { code: 'ag', name: 'Antigua and Barbuda', defaultFiat: 'USD' },
  { code: 'al', name: 'Albania', defaultFiat: 'ALL' },
  { code: 'am', name: 'Armenia', defaultFiat: 'USD' },
  { code: 'ao', name: 'Angola', defaultFiat: 'USD' },
  { code: 'ar', name: 'Argentina', defaultFiat: 'ARS' },
  { code: 'at', name: 'Austria', defaultFiat: 'EUR' },
  { code: 'au', name: 'Australia', defaultFiat: 'AUD' },
  { code: 'az', name: 'Azerbaijan', defaultFiat: 'USD' },
  { code: 'ba', name: 'Bosnia and Herzegovina', defaultFiat: 'EUR' },
  { code: 'bb', name: 'Barbados', defaultFiat: 'USD' },
  { code: 'bd', name: 'Bangladesh', defaultFiat: 'USD' },
  { code: 'be', name: 'Belgium', defaultFiat: 'EUR' },
  { code: 'bf', name: 'Burkina Faso', defaultFiat: 'USD' },
  { code: 'bg', name: 'Bulgaria', defaultFiat: 'EUR' },
  { code: 'bh', name: 'Bahrain', defaultFiat: 'USD' },
  { code: 'bi', name: 'Burundi', defaultFiat: 'USD' },
  { code: 'bj', name: 'Benin', defaultFiat: 'USD' },
  { code: 'bn', name: 'Brunei', defaultFiat: 'USD' },
  { code: 'bo', name: 'Bolivia', defaultFiat: 'USD' },
  { code: 'br', name: 'Brazil', defaultFiat: 'BRL' },
  { code: 'bs', name: 'Bahamas', defaultFiat: 'USD' },
  { code: 'bt', name: 'Bhutan', defaultFiat: 'USD' },
  { code: 'bw', name: 'Botswana', defaultFiat: 'USD' },
  { code: 'by', name: 'Belarus', defaultFiat: 'USD' },
  { code: 'bz', name: 'Belize', defaultFiat: 'USD' },
  { code: 'ca', name: 'Canada', defaultFiat: 'CAD' },
  { code: 'cd', name: 'DR Congo', defaultFiat: 'USD' },
  { code: 'cf', name: 'Central African Republic', defaultFiat: 'USD' },
  { code: 'ch', name: 'Switzerland', defaultFiat: 'CHF' },
  { code: 'ci', name: "Cote d'Ivoire", defaultFiat: 'USD' },
  { code: 'cl', name: 'Chile', defaultFiat: 'CLP' },
  { code: 'cm', name: 'Cameroon', defaultFiat: 'USD' },
  { code: 'cn', name: 'China', defaultFiat: 'USD' },
  { code: 'co', name: 'Colombia', defaultFiat: 'USD' },
  { code: 'cr', name: 'Costa Rica', defaultFiat: 'USD' },
  { code: 'cu', name: 'Cuba', defaultFiat: 'USD' },
  { code: 'cv', name: 'Cape Verde', defaultFiat: 'USD' },
  { code: 'cy', name: 'Cyprus', defaultFiat: 'EUR' },
  { code: 'cz', name: 'Czech Republic', defaultFiat: 'CZK' },
  { code: 'de', name: 'Germany', defaultFiat: 'EUR' },
  { code: 'dj', name: 'Djibouti', defaultFiat: 'USD' },
  { code: 'dk', name: 'Denmark', defaultFiat: 'DKK' },
  { code: 'dm', name: 'Dominica', defaultFiat: 'USD' },
  { code: 'do', name: 'Dominican Republic', defaultFiat: 'USD' },
  { code: 'dz', name: 'Algeria', defaultFiat: 'USD' },
  { code: 'ec', name: 'Ecuador', defaultFiat: 'USD' },
  { code: 'ee', name: 'Estonia', defaultFiat: 'EUR' },
  { code: 'eg', name: 'Egypt', defaultFiat: 'USD' },
  { code: 'er', name: 'Eritrea', defaultFiat: 'USD' },
  { code: 'es', name: 'Spain', defaultFiat: 'EUR' },
  { code: 'et', name: 'Ethiopia', defaultFiat: 'USD' },
  { code: 'fi', name: 'Finland', defaultFiat: 'EUR' },
  { code: 'fj', name: 'Fiji', defaultFiat: 'USD' },
  { code: 'fr', name: 'France', defaultFiat: 'EUR' },
  { code: 'ga', name: 'Gabon', defaultFiat: 'USD' },
  { code: 'gb', name: 'United Kingdom', defaultFiat: 'GBP' },
  { code: 'gd', name: 'Grenada', defaultFiat: 'USD' },
  { code: 'ge', name: 'Georgia', defaultFiat: 'USD' },
  { code: 'gh', name: 'Ghana', defaultFiat: 'USD' },
  { code: 'gm', name: 'Gambia', defaultFiat: 'USD' },
  { code: 'gn', name: 'Guinea', defaultFiat: 'USD' },
  { code: 'gq', name: 'Equatorial Guinea', defaultFiat: 'USD' },
  { code: 'gr', name: 'Greece', defaultFiat: 'EUR' },
  { code: 'gt', name: 'Guatemala', defaultFiat: 'USD' },
  { code: 'gw', name: 'Guinea-Bissau', defaultFiat: 'USD' },
  { code: 'gy', name: 'Guyana', defaultFiat: 'USD' },
  { code: 'hk', name: 'Hong Kong', defaultFiat: 'HKD' },
  { code: 'hn', name: 'Honduras', defaultFiat: 'USD' },
  { code: 'hr', name: 'Croatia', defaultFiat: 'EUR' },
  { code: 'ht', name: 'Haiti', defaultFiat: 'USD' },
  { code: 'hu', name: 'Hungary', defaultFiat: 'EUR' },
  { code: 'id', name: 'Indonesia', defaultFiat: 'IDR' },
  { code: 'ie', name: 'Ireland', defaultFiat: 'EUR' },
  { code: 'il', name: 'Israel', defaultFiat: 'USD' },
  { code: 'in', name: 'India', defaultFiat: 'INR' },
  { code: 'iq', name: 'Iraq', defaultFiat: 'USD' },
  { code: 'ir', name: 'Iran', defaultFiat: 'USD' },
  { code: 'is', name: 'Iceland', defaultFiat: 'EUR' },
  { code: 'it', name: 'Italy', defaultFiat: 'EUR' },
  { code: 'jm', name: 'Jamaica', defaultFiat: 'USD' },
  { code: 'jo', name: 'Jordan', defaultFiat: 'USD' },
  { code: 'jp', name: 'Japan', defaultFiat: 'JPY' },
  { code: 'ke', name: 'Kenya', defaultFiat: 'USD' },
  { code: 'kg', name: 'Kyrgyzstan', defaultFiat: 'USD' },
  { code: 'kh', name: 'Cambodia', defaultFiat: 'USD' },
  { code: 'ki', name: 'Kiribati', defaultFiat: 'USD' },
  { code: 'km', name: 'Comoros', defaultFiat: 'USD' },
  { code: 'kn', name: 'Saint Kitts and Nevis', defaultFiat: 'USD' },
  { code: 'kr', name: 'South Korea', defaultFiat: 'KRW' },
  { code: 'kw', name: 'Kuwait', defaultFiat: 'USD' },
  { code: 'kz', name: 'Kazakhstan', defaultFiat: 'USD' },
  { code: 'la', name: 'Laos', defaultFiat: 'USD' },
  { code: 'lb', name: 'Lebanon', defaultFiat: 'USD' },
  { code: 'lc', name: 'Saint Lucia', defaultFiat: 'USD' },
  { code: 'li', name: 'Liechtenstein', defaultFiat: 'CHF' },
  { code: 'lk', name: 'Sri Lanka', defaultFiat: 'USD' },
  { code: 'lr', name: 'Liberia', defaultFiat: 'USD' },
  { code: 'ls', name: 'Lesotho', defaultFiat: 'ZAR' },
  { code: 'lt', name: 'Lithuania', defaultFiat: 'EUR' },
  { code: 'lu', name: 'Luxembourg', defaultFiat: 'EUR' },
  { code: 'lv', name: 'Latvia', defaultFiat: 'EUR' },
  { code: 'ly', name: 'Libya', defaultFiat: 'USD' },
  { code: 'ma', name: 'Morocco', defaultFiat: 'USD' },
  { code: 'mc', name: 'Monaco', defaultFiat: 'EUR' },
  { code: 'md', name: 'Moldova', defaultFiat: 'EUR' },
  { code: 'me', name: 'Montenegro', defaultFiat: 'EUR' },
  { code: 'mg', name: 'Madagascar', defaultFiat: 'USD' },
  { code: 'mk', name: 'North Macedonia', defaultFiat: 'EUR' },
  { code: 'ml', name: 'Mali', defaultFiat: 'USD' },
  { code: 'mm', name: 'Myanmar', defaultFiat: 'USD' },
  { code: 'mn', name: 'Mongolia', defaultFiat: 'USD' },
  { code: 'mr', name: 'Mauritania', defaultFiat: 'USD' },
  { code: 'mt', name: 'Malta', defaultFiat: 'EUR' },
  { code: 'mu', name: 'Mauritius', defaultFiat: 'USD' },
  { code: 'mv', name: 'Maldives', defaultFiat: 'USD' },
  { code: 'mw', name: 'Malawi', defaultFiat: 'USD' },
  { code: 'mx', name: 'Mexico', defaultFiat: 'MXN' },
  { code: 'my', name: 'Malaysia', defaultFiat: 'USD' },
  { code: 'mz', name: 'Mozambique', defaultFiat: 'USD' },
  { code: 'na', name: 'Namibia', defaultFiat: 'ZAR' },
  { code: 'ne', name: 'Niger', defaultFiat: 'USD' },
  { code: 'ng', name: 'Nigeria', defaultFiat: 'NGN' },
  { code: 'ni', name: 'Nicaragua', defaultFiat: 'USD' },
  { code: 'nl', name: 'Netherlands', defaultFiat: 'EUR' },
  { code: 'no', name: 'Norway', defaultFiat: 'NOK' },
  { code: 'np', name: 'Nepal', defaultFiat: 'USD' },
  { code: 'nr', name: 'Nauru', defaultFiat: 'AUD' },
  { code: 'nz', name: 'New Zealand', defaultFiat: 'NZD' },
  { code: 'om', name: 'Oman', defaultFiat: 'USD' },
  { code: 'pa', name: 'Panama', defaultFiat: 'USD' },
  { code: 'pe', name: 'Peru', defaultFiat: 'USD' },
  { code: 'pg', name: 'Papua New Guinea', defaultFiat: 'USD' },
  { code: 'ph', name: 'Philippines', defaultFiat: 'PHP' },
  { code: 'pk', name: 'Pakistan', defaultFiat: 'USD' },
  { code: 'pl', name: 'Poland', defaultFiat: 'PLN' },
  { code: 'pt', name: 'Portugal', defaultFiat: 'EUR' },
  { code: 'pw', name: 'Palau', defaultFiat: 'USD' },
  { code: 'py', name: 'Paraguay', defaultFiat: 'USD' },
  { code: 'qa', name: 'Qatar', defaultFiat: 'QAR' },
  { code: 'ro', name: 'Romania', defaultFiat: 'EUR' },
  { code: 'rs', name: 'Serbia', defaultFiat: 'EUR' },
  { code: 'ru', name: 'Russia', defaultFiat: 'USD' },
  { code: 'rw', name: 'Rwanda', defaultFiat: 'USD' },
  { code: 'sa', name: 'Saudi Arabia', defaultFiat: 'SAR' },
  { code: 'sb', name: 'Solomon Islands', defaultFiat: 'USD' },
  { code: 'sc', name: 'Seychelles', defaultFiat: 'USD' },
  { code: 'sd', name: 'Sudan', defaultFiat: 'USD' },
  { code: 'se', name: 'Sweden', defaultFiat: 'SEK' },
  { code: 'sg', name: 'Singapore', defaultFiat: 'SGD' },
  { code: 'si', name: 'Slovenia', defaultFiat: 'EUR' },
  { code: 'sk', name: 'Slovakia', defaultFiat: 'EUR' },
  { code: 'sl', name: 'Sierra Leone', defaultFiat: 'USD' },
  { code: 'sm', name: 'San Marino', defaultFiat: 'EUR' },
  { code: 'sn', name: 'Senegal', defaultFiat: 'USD' },
  { code: 'so', name: 'Somalia', defaultFiat: 'USD' },
  { code: 'sr', name: 'Suriname', defaultFiat: 'USD' },
  { code: 'ss', name: 'South Sudan', defaultFiat: 'USD' },
  { code: 'sv', name: 'El Salvador', defaultFiat: 'USD' },
  { code: 'sy', name: 'Syria', defaultFiat: 'USD' },
  { code: 'sz', name: 'Eswatini', defaultFiat: 'ZAR' },
  { code: 'td', name: 'Chad', defaultFiat: 'USD' },
  { code: 'tg', name: 'Togo', defaultFiat: 'USD' },
  { code: 'th', name: 'Thailand', defaultFiat: 'THB' },
  { code: 'tj', name: 'Tajikistan', defaultFiat: 'USD' },
  { code: 'tl', name: 'Timor-Leste', defaultFiat: 'USD' },
  { code: 'tm', name: 'Turkmenistan', defaultFiat: 'USD' },
  { code: 'tn', name: 'Tunisia', defaultFiat: 'USD' },
  { code: 'to', name: 'Tonga', defaultFiat: 'USD' },
  { code: 'tr', name: 'Turkey', defaultFiat: 'TRY' },
  { code: 'tt', name: 'Trinidad and Tobago', defaultFiat: 'USD' },
  { code: 'tv', name: 'Tuvalu', defaultFiat: 'AUD' },
  { code: 'tw', name: 'Taiwan', defaultFiat: 'TWD' },
  { code: 'tz', name: 'Tanzania', defaultFiat: 'USD' },
  { code: 'ua', name: 'Ukraine', defaultFiat: 'USD' },
  { code: 'ug', name: 'Uganda', defaultFiat: 'USD' },
  { code: 'us', name: 'United States', defaultFiat: 'USD' },
  { code: 'uy', name: 'Uruguay', defaultFiat: 'USD' },
  { code: 'uz', name: 'Uzbekistan', defaultFiat: 'USD' },
  { code: 'va', name: 'Vatican City', defaultFiat: 'EUR' },
  { code: 'vc', name: 'Saint Vincent and the Grenadines', defaultFiat: 'USD' },
  { code: 've', name: 'Venezuela', defaultFiat: 'USD' },
  { code: 'vn', name: 'Vietnam', defaultFiat: 'VND' },
  { code: 'vu', name: 'Vanuatu', defaultFiat: 'USD' },
  { code: 'ws', name: 'Samoa', defaultFiat: 'USD' },
  { code: 'ye', name: 'Yemen', defaultFiat: 'USD' },
  { code: 'za', name: 'South Africa', defaultFiat: 'ZAR' },
  { code: 'zm', name: 'Zambia', defaultFiat: 'USD' },
  { code: 'zw', name: 'Zimbabwe', defaultFiat: 'USD' },
];

/** Precomputed lookup by country code */
export const COUNTRY_MAP: Record<string, Country> = Object.fromEntries(
  COUNTRIES.map((c) => [c.code, c])
);

/**
 * Resolve the default fiat currency for a country.
 * Validates against available fiats, falls back to USD then first available.
 */
export function getDefaultFiatForCountry(
  countryCode: string | undefined | null,
  supportedFiats?: string[]
): string {
  if (!countryCode) return 'USD';

  const country = COUNTRY_MAP[countryCode.toLowerCase()];
  const preferredFiat = country?.defaultFiat || 'USD';

  // If no supported fiats list, return the preferred fiat directly
  if (!supportedFiats || supportedFiats.length === 0) return preferredFiat;

  // Check if the country's default fiat is supported
  if (supportedFiats.includes(preferredFiat)) return preferredFiat;

  // Fall back to USD if supported
  if (supportedFiats.includes('USD')) return 'USD';

  // Last resort: first available fiat
  return supportedFiats[0] || 'USD';
}
